module.exports = {
    CONECTION_ERROR: 'Error de conexíon con el servidor',
    DEFAULT_ERROR: 'Error',
}
